

export default {
    install: async (Vue) => {
    // Set dictionaries on prototipe, for global use
        Vue.prototype.$dic = {
            one: 'two',
            two: 'three',
            meses: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
        }
    },
}
